import Clock from '../src/Clock';
export default Clock;
